/*
 * @Description: 为卡片添加渐变边框
 * @Author: F-Stone
 * @LastEditTime: 2025-08-13 14:46:49
 */
import mitt from "mitt";

/**
 * 为卡片添加渐变边框
 * @param {Object} vm Vue实例
 * @param {HTMLElement} lighterDomsRef 卡片元素
 * @param {string} selector 选择器字符串
 */
export function useLighterBorder(vm, lighterDomsRef, selector) {
  const eventBus = mitt();

  function initLighterBorder() {
    const lighterDoms = selector
      ? lighterDomsRef.querySelectorAll(selector)
      : [lighterDomsRef];

    lighterDoms.forEach((cardItemDom) => {
      if (!cardItemDom) return;

      if (!cardItemDom.classList.contains("effect-lighter-dom")) {
        cardItemDom.classList.add("effect-lighter-dom");
      }

      function handlePointerMove(ev) {
        if (!cardItemDom) return;

        const { x, y } = cardItemDom.getBoundingClientRect();
        const { clientX, clientY } = ev;
        const { width, height } = cardItemDom.getBoundingClientRect();
        const xPercent = (clientX - x) / width;
        const yPercent = (clientY - y) / height;
        
        // 使用Vue 2的$gsap或直接设置CSS变量
        if (vm.$gsap) {
          vm.$gsap.set(cardItemDom, {
            "--x": `${xPercent * 100}%`,
            "--y": `${yPercent * 100}%`,
          });
        } else {
          // 直接设置CSS变量
          cardItemDom.style.setProperty("--x", `${xPercent * 100}%`);
          cardItemDom.style.setProperty("--y", `${yPercent * 100}%`);
        }
      }

      cardItemDom.addEventListener("pointermove", handlePointerMove);
      eventBus.on("destroy", () => {
        cardItemDom.removeEventListener("pointermove", handlePointerMove);
      });
    });
  }

  // Vue 2 生命周期钩子
  vm.$nextTick(() => {
    if (CSS.supports("mask-composite", "xor") || CSS.supports("mask-composite", "exclude")) {
      initLighterBorder();
    }
  });

  // 返回清理函数，在组件销毁时调用
  return function cleanup() {
    eventBus.emit("destroy");
    eventBus.all.clear();
  };
}
